// extracted by mini-css-extract-plugin
module.exports = {"composer__actions":"composer__actions__3eA8B"};